// Blotout consent helper
// Wraps window[Symbol.for('blotout-consent')] APIs with debug logs
// and a delegated click handler bound to [data-blotout-action] elements.
/*
(() => {
  const MAX_ATTEMPTS = 20
  const RETRY_DELAY_MS = 500

  const findCloseTarget = () => {
    const banner = document
      .querySelector('blotout-consent')
      ?.shadowRoot?.querySelector('consent-banner')
    return banner?.shadowRoot?.querySelector('div') ?? null
  }

  const closeConsentBanner = (attempt = 1) => {
    const container = findCloseTarget()
    if (!container) {
      if (attempt < MAX_ATTEMPTS) {
        setTimeout(() => closeConsentBanner(attempt + 1), RETRY_DELAY_MS)
      }
      return
    }
    // Reuse the banner's existing close flow: `dialog-closed` is the same
    // bubbling/composed CustomEvent the close button fires, which
    // consent-banner listens for to dismiss the popup.
    container.dispatchEvent(
      new CustomEvent('dialog-closed', { bubbles: true, composed: true })
    )
  }

  window.addEventListener('edgetag-initialized', (e) => {
    const { geoCountry } = e.detail ?? {}
    if (geoCountry === 'US') {
      closeConsentBanner()
    }
  })
})();
*/

(function () {
  const CONSENT_SYMBOL = Symbol.for('blotout-consent');
  const LOG_PREFIX = '[blotout-consent]';

  function getConsentApi() {
    const api = window[CONSENT_SYMBOL];
    if (!api) {
      console.error(`${LOG_PREFIX} API not yet available on window[Symbol.for('blotout-consent')]`);
      return null;
    }
    return api;
  }

  function callConsentMethod(methodName) {
    const api = getConsentApi();
    if (!api) return;
    if (typeof api[methodName] !== 'function') {
      console.error(`${LOG_PREFIX} method "${methodName}" is not a function`, api);
      return;
    }
    try {
      api[methodName]();
    } catch (err) {
      console.error(`${LOG_PREFIX} error calling ${methodName}()`, err);
    }
  }

  function showBanner() {
    callConsentMethod('showBanner');
  }

  function showDnsForm() {
    callConsentMethod('showDnsForm');
  }

  function showDeleteForm() {
    callConsentMethod('showDeleteForm');
  }

  const actionHandlers = {
    'show-banner': showBanner,
    'show-dns-form': showDnsForm,
    'show-delete-form': showDeleteForm,
  };

  function handleDelegatedClick(event) {
    const trigger = event.target.closest('[data-blotout-action]');
    if (!trigger) return;
    const action = trigger.getAttribute('data-blotout-action');
    const handler = actionHandlers[action];
    if (!handler) {
      console.error(`${LOG_PREFIX} unknown data-blotout-action "${action}"`, trigger);
      return;
    }
    event.preventDefault();
    handler();
  }

  document.addEventListener('click', handleDelegatedClick);

  window.tcBlotoutConsent = {
    showBanner,
    showDnsForm,
    showDeleteForm,
  };

  /*
  document.addEventListener('bc-delete-request-failed', (e) => {
    const formEl = e.composedPath()[0]; 
    formEl.dispatchEvent(new CustomEvent('bc-delete-form-closed', {
      bubbles: true, composed: true, detail: null
    }));
  }, true);
  */
})();
